import type { ProgramsNew } from '@/types/programs-new/programs-new'

export function useHasAtLeastOneDeviceEnrollment(
  enrolledProgram: Pick<ProgramsNew, 'enrollment_overview'> | null | undefined,
): boolean {
  const enrollmentOverview = enrolledProgram?.enrollment_overview
  return (
    !!enrollmentOverview &&
    [
      enrollmentOverview.vehicle_enrollments ?? [],
      enrollmentOverview.thermostat_enrollments ?? [],
      enrollmentOverview.charger_enrollments ?? [],
      enrollmentOverview.behavioral_enrollments ?? [],
      enrollmentOverview.energy_system_enrollments ?? [],
    ].some((enrollments) => enrollments.some((e) => e.enrolled))
  )
}
